// StatusButton.tsx
import React, {FC} from 'react'
import SyncMessageBadge from './components/SyncMessageBadge'
import {
  formatSyncStatusLabel,
  getSyncStatusBadgeBackgroundColor,
  normalizeSyncStatus,
  shouldShowSyncStatusPopover,
} from './syncStatusDisplayUtils'

interface StatusButtonProps {
  syncStatus: string
  syncMessage?: string
  customText?: string
}

const StatusButton: FC<StatusButtonProps> = ({syncStatus, syncMessage, customText}) => {
  const normalizedStatus = normalizeSyncStatus(syncStatus)
  const buttonContent = customText ?? formatSyncStatusLabel(syncStatus)

  return (
    <SyncMessageBadge
      syncMessage={syncMessage}
      showPopover={shouldShowSyncStatusPopover(normalizedStatus)}
      badgeContent={buttonContent}
      badgeStyle={{
        backgroundColor: getSyncStatusBadgeBackgroundColor(normalizedStatus),
        color: normalizedStatus === 'PENDING_APPROVAL' ? 'black' : 'white',
        padding: '4px 10px',
        border: 'none',
        cursor: 'pointer',
        minWidth: '100px',
        fontWeight: 500,
        fontSize: '11px',
      }}
    />
  )
}

export default StatusButton
